"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamResponseError = exports.StreamInternalError = exports.CorebeStreamReadResult = exports.StreamReadResult = exports.StreamDataChoiceMessage = exports.CorebeStreamDataItemChoices = exports.CorebeStreamDataItem = exports.CorebeStreamUtil = exports.CorebeStreamResponse = exports.handleResponse = exports.CorebeStreamClient = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const class_transformer_1 = require("class-transformer");
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const qs_1 = __importDefault(require("qs"));
const JsonUtil_1 = require("../cutil/JsonUtil");
const LangUtil_1 = require("../cutil/LangUtil");
const RestClient_1 = require("../cutil/RestClient");
const Value_1 = require("../cutil/Value");
const GenUtil_1 = require("../cutil/GenUtil");
const StreamClient_1 = require("../cutil/StreamClient");
class CorebeStreamClient {
    constructor(adapter, abortManager = undefined) {
        this.adapter = adapter;
        this.abortManager = abortManager;
    }
    async request(params) {
        const adapter = await (async () => this.adapter)();
        const url = adapter.baseUrl + params.path;
        const header = Object.assign({ "Content-Type": "application/json" }, adapter.headers, params.headers ?? {});
        let option = {
            method: params.method ?? StreamClient_1.RestMethod.POST,
            headers: header,
        };
        if (option.method === StreamClient_1.RestMethod.POST) {
            option.body = (0, LangUtil_1.tryBlock)(() => JSON.stringify(params.data)).data;
        }
        const fullUrl = CorebeStreamUtil.stringifyQueryParameters(url, params.queryParameters);
        let uuid = params.uuid || GenUtil_1.GenUtil.randomString();
        const abortController = new AbortController();
        if (this.abortManager) {
            this.abortManager.add(uuid, abortController, {
                path: fullUrl,
                method: option.method.toString(),
                data: option.body?.toString(),
                queryParameters: params.queryParameters,
                headers: option.headers,
            });
        }
        option = { ...option, signal: abortController.signal };
        const res = await (0, LangUtil_1.tryPromise)(fetch(fullUrl, option));
        return handleResponse(res, adapter, () => {
            if (this.abortManager) {
                this.abortManager.abort({ uuid: uuid });
            }
        });
    }
}
exports.CorebeStreamClient = CorebeStreamClient;
async function handleResponse(tryRes, adapter, abort, isJsonSteaming) {
    if (tryRes.error) {
        const errorRes = new StreamInternalError(tryRes.error);
        adapter?.errorHandler(errorRes);
        throw errorRes;
    }
    const response = tryRes.data;
    const streamResponse = new CorebeStreamResponse(response, abort, adapter);
    if (!streamResponse.isSuccess()) {
        const getErrorJsonPromise = new Promise((resolve, reject) => {
            streamResponse.onReceived(result => {
                const fullText = result.fullText;
                if ((0, is_blank_1.default)(fullText)) {
                    resolve({});
                    return;
                }
                const json = JSON.parse(fullText);
                resolve(json);
            });
        });
        const json = await (0, LangUtil_1.tryPromise)(getErrorJsonPromise);
        if (json.error) {
            adapter.errorHandler(json.error);
            throw json.error;
        }
        const errorRes = new StreamInternalError(json.data);
        adapter?.errorHandler(errorRes);
        throw errorRes;
    }
    return streamResponse;
}
exports.handleResponse = handleResponse;
class CorebeStreamResponse {
    constructor(response, abort, adapter) {
        this.response = response;
        this.abort = abort;
        this.adapter = adapter;
        this.decoder = new TextDecoder();
        const reader = response.body?.getReader();
        console.log("stream", response);
        if (reader == null) {
            console.log("stream", "reader is null");
            return;
        }
        const eventEmitter = new eventemitter3_1.default();
        this.eventEmitter = eventEmitter;
        const fulltextValue = new Value_1.Value("");
        this.fulltextValue = fulltextValue;
        const doneValue = new Value_1.Value(false);
        this.doneValue = doneValue;
        const decoder = this.decoder;
        let receiveString = "";
        function receive(reader) {
            reader
                .read()
                .then((res) => {
                if (res.done) {
                    doneValue.value = res.done;
                    fulltextValue.value = fulltextValue.value + receiveString;
                    console.log("请求完成", res);
                    eventEmitter.emit(CorebeStreamResponse.RECEIVED_EVENT, new CorebeStreamReadResult("", "", "", () => abort()));
                    return;
                }
                const uint8Array = res.value ?? [];
                // let resString = String.fromCharCode(...uint8Array);
                let resString = decoder.decode(uint8Array);
                receiveString = receiveString + resString;
                const parseResult = CorebeStreamUtil.parse(receiveString);
                receiveString = parseResult.remainder;
                for (const dataItem of parseResult.dataItems) {
                    const dataItemTyped = JsonUtil_1.JsonUtil.toModelFromType(CorebeStreamDataItem, dataItem);
                    const id = dataItemTyped?.id ?? "";
                    const content = dataItemTyped?.content ?? "";
                    const state = dataItemTyped?.state ?? "";
                    if (eventEmitter.listenerCount(CorebeStreamResponse.RECEIVED_EVENT) > 0) {
                        eventEmitter.emit(CorebeStreamResponse.RECEIVED_EVENT, new CorebeStreamReadResult(id, content, state, () => abort()));
                    }
                }
                receive(reader);
            })
                .catch(error => {
                fulltextValue.value = fulltextValue.value;
                const basicError = new RestClient_1.RestInternalError(error);
                adapter?.errorHandler(basicError);
                eventEmitter.emit(CorebeStreamResponse.RECEIVED_EVENT, new CorebeStreamReadResult("", "", "", () => abort(), basicError));
            });
        }
        receive(reader);
    }
    onReceived(listener) {
        this.eventEmitter.on(CorebeStreamResponse.RECEIVED_EVENT, msg => {
            listener(msg);
        });
        if (this.fulltextValue.value.length > 0) {
            this.eventEmitter.emit(CorebeStreamResponse.RECEIVED_EVENT, new StreamReadResult(this.doneValue.value, this.fulltextValue.value, this.fulltextValue.value, () => this.abort()));
        }
    }
    isSuccess() {
        return this.response.status >= 200 && this.response.status < 300;
    }
    validate() {
        if (!this.isSuccess) {
            throw new StreamResponseError(this);
        }
        return this;
    }
    get errorDescription() {
        if (this.parseErrorHandler != null) {
            const message = this.parseErrorHandler(this);
            if (!(0, is_blank_1.default)(message)) {
                return message;
            }
        }
        return undefined;
    }
}
exports.CorebeStreamResponse = CorebeStreamResponse;
CorebeStreamResponse.RECEIVED_EVENT = "received";
class CorebeStreamUtil {
    static stringifyQueryParameters(url, queryParameters) {
        if (queryParameters == undefined || (0, is_blank_1.default)(queryParameters))
            return url;
        const str = qs_1.default.stringify(queryParameters);
        return url.indexOf("?") > -1 ? `${url}&${str}` : `${url}?${str}`;
    }
    static parse(source) {
        let dataItems = [];
        let chars = [];
        for (let char of source) {
            if (char == "\n") {
                if (chars.length > 0) {
                    let str1 = chars.join("").trim();
                    /// 删除数据项开头的字符：data:
                    if (str1.startsWith("data: ")) {
                        str1 = str1.substring(6);
                    }
                    if (str1 != "[DONE]") {
                        dataItems.push(str1);
                    }
                    chars = [];
                }
            }
            else {
                chars.push(char);
            }
        }
        const remainder = chars.join("");
        return { dataItems: dataItems, remainder: remainder };
    }
}
exports.CorebeStreamUtil = CorebeStreamUtil;
class CorebeStreamDataItem {
}
exports.CorebeStreamDataItem = CorebeStreamDataItem;
class CorebeStreamDataItemChoices {
}
exports.CorebeStreamDataItemChoices = CorebeStreamDataItemChoices;
__decorate([
    (0, class_transformer_1.Type)(() => StreamDataChoiceMessage)
], CorebeStreamDataItemChoices.prototype, "message", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => StreamDataChoiceMessage)
], CorebeStreamDataItemChoices.prototype, "delta", void 0);
class StreamDataChoiceMessage {
}
exports.StreamDataChoiceMessage = StreamDataChoiceMessage;
class StreamReadResult {
    constructor(done, fullText, choiceText, abort, error) {
        this.done = done;
        this.fullText = fullText;
        this.choiceText = choiceText;
        this.abort = abort;
        this.error = error;
    }
}
exports.StreamReadResult = StreamReadResult;
class CorebeStreamReadResult {
    constructor(id, content, state, abort, error) {
        this.id = id;
        this.content = content;
        this.state = state;
        this.abort = abort;
        this.error = error;
    }
}
exports.CorebeStreamReadResult = CorebeStreamReadResult;
class StreamInternalError {
    constructor(jsonData) {
        this.jsonData = jsonData;
    }
    parseError(handler) {
        this.parseErrorHandler = response => handler(response);
        return this;
    }
    get errorDescription() {
        if (this.parseErrorHandler != null) {
            const message = this.parseErrorHandler(this);
            if (!(0, is_blank_1.default)(message)) {
                return message;
            }
        }
        return undefined;
    }
}
exports.StreamInternalError = StreamInternalError;
class StreamResponseError extends CorebeStreamResponse {
    constructor(response) {
        super(response.response, response.abort, response.adapter);
        this.parseErrorHandler = response.parseErrorHandler;
    }
}
exports.StreamResponseError = StreamResponseError;
